<template>
   <div class="col-md-12" style="margin-bottom: 50px;">
        <b-container style="margin-top: 50px; margin-bottom: 80px;">
        <b-row>
        <b-col sm="1">
        </b-col>
        <b-col sm="10">
        <div class="row">
        <div class="col-md-12" style="">
            <p style=" font-size:18px; font-weight: bold; "> </p>
        </div>
        </div>

        <div class="">
            <b-table :items="fetchData" >
            </b-table>
        </div>
         <!--<b-container>
            <div class="row">
            <div class="col-md-6 col-container" style="background-color:#00A2E4;">
                <div class="row">
                <b-col sm="12" class="mt-5">
                <div class="item-container" v-for="(item, index) in totalItems" v-bind:key="index">
                 <h6 v-for="index in item" v-bind:key="index">
                     <h5 v-if="index.id == 1">
                <a  style="color:white; font-size:30px;" :href="index.link" target="_BLANK">{{index.year}}</a>
                </h5>
                </h6>
                </div>
                </b-col>
                </div>
            </div>
            <div class="col-md-6 col-container-right" style="background-color:#B1ADAD;">
                <div class="row">
                <b-col sm="12" class="mt-5">
                <div class="item-container" v-for="(item, index) in totalItems" v-bind:key="index">
                 <h6 v-for="index in item" v-bind:key="index">
                     <h5 v-if="index.id == 2">
                <a  style="color:#1D1D1D; font-size:30px;" :href="index.link" target="_BLANK">{{index.year}}</a>
                </h5>
                </h6>
                </div>
                </b-col>
                </div>
            </div>
            </div>
         </b-container>
         <b-container>
            <div class="row">
            <div class="col-md-6 col-container" style="background-color:#DDDBDB;">
                <div class="row">
                <b-col sm="12" class="mt-5">
                <div class="item-container" v-for="(item, index) in totalItems" v-bind:key="index">
                 <h6 v-for="index in item" v-bind:key="index">
                     <h5 v-if="index.id == 3">
                <a  style="color:#1D1D1D; font-size:30px;" :href="index.link" target="_BLANK">{{index.year}}</a>
                </h5>
                </h6>
                </div>
                </b-col>
                </div>
            </div>
            <div class="col-md-6 col-container-right" style="background-color:#9BC455;">
                <div class="row">
                <b-col sm="12" class="mt-5">
                <div class="item-container" v-for="(item, index) in totalItems" v-bind:key="index">
                 <h6 v-for="index in item" v-bind:key="index">
                     <h5 v-if="index.id == 4">
                <a style="color:white; font-size:30px;" :href="index.link" target="_BLANK">{{index.year}}</a>
                </h5>
                </h6>
                </div>
                </b-col>
                </div>
            </div>
            </div>
         </b-container>-->
         <div class="row" style="">
            <div class="col-md-2"  v-for="(item,index) in totalItems"  v-bind:key="index" >
                <div style="background-color: #d9d9d9; padding: 10px; text-align: center;">
                    <a class="text-center" style="text-decoration:none;  color:black; font-size:16px;font-weight:600; max-width:3ch;" :href="item[0].link" target="_BLANK"> 
                        <p   style="text-decoration:none; font-weight:bold;  color:#4d4d4d; ">
                            UNEP Programme of Work and Budget 
                        <br/>
                        {{item[0].year}}
                    </p>
                    
                </a>
                 </div>
            </div>
        </div>


         <!--div class="row" style="">
                    <div class="col column_wrapper" style="">
                        
                        <div style="margin-bottom: 20px;" class="col-md-2" v-for="(item,index) in totalItems"  v-bind:key="index" >
                            <a class="text-center" style="text-decoration:none;  color:black; font-size:16px;font-weight:600; max-width:3ch;" :href="item[0].link" target="_BLANK"> 
                                
                                <b-card-text style="margin-left: 20px;" class="align-items-center d-flex justify-content-center" :style="'background-color: #d9d9d9; '" >
                                        <div class="align-items-center d-flex justify-content-center" style="width: 0%;" >
                                            <p class="col-md-3" style="text-decoration:none; font-weight:bold;  color:#4d4d4d; ">
                                                {{item[0].title}}
                                                <br/>
                                                {{item[0].year}}
                                            </p>
                                        </div>
                                </b-card-text>
                            </a>
                    </div>
                    </div>
        </div-->

        <div v-bind:hidden="loadedData" id="loadingGif" style="text-align: center;">
            <img src="../assets/loading.gif" style="text-align: center; height: 100px;">
        </div>
        </b-col>
        <b-col sm="1"> 
        </b-col>
        </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'PoW',
        data() {
            return {
                loadedData: false,
                apiUrl: process.env.VUE_APP_API_PATH,
                items: [],
                filter: null,
                cols:2,
                color: '',
                counter: 0,
                filterValue: '',
                filterBy: 'year',
                filterOn: [],
                isEditing: false,
                small: false,
                sortBy: 'year',
                sortDesc: false,
                sortDirection: 'asc',
                pageOptions: [5, 10, 15],
                fields: [
                    {
                        key: 'year',
                        label: 'PoW',
                        sortable: true,
                        searchable: true,
                    },
                    {
                        key: 'link',
                        label: 'Link',
                        sortable: true,
                        searchable: true,
                    },
                ],
                currentPage: 1,
                perPage: 10,
                totalItems: [],
            }
        },
        computed: {
            columns: function() {
              let columns = [];
              let mid = Math.ceil(Object.keys(this.totalItems).length / this.cols);

              for (let col = 0; col < this.cols; col++) {
                  columns.push(Object.entries(this.totalItems).slice(col * mid, col * mid + mid).map(entry => entry[1]));
              }
              return columns;
          },

            sortOptions() {
                // Create an options list from our fields
                return this.fields
                    .filter(f => f.searchable)
                    .map(f => {
                        return {text: f.label, value: f.key}
                    })
            },
        },
        methods: {
            choseColor(m) {
            if((m % 4) == 0){
                return `#9BC455`;
            }else if((m % 4) == 1){
                return `#00A2E4`;
            }else if ((m % 4) == 2){
                return `#DDDBDB`;
            }else if ((m % 4) == 3){
            return `#B1ADAD`;
            }
            },
            filterOutcomes() {
                this.currentPage = 1
                this.$refs.tableOutcomes.refresh();
                this.loadedData = false;
            },
            fetchData(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDesc ? 'asc' : 'desc';
                fetch(url + '/getpow?_page=' + `${this.currentPage}&_limit=${this.perPage}&_filterBy=${this.filterBy}&_sortBy=${this.sortBy}&_sortDirection=${sortD}&_filter=${this.filterValue}`)
                    .then(res => res.json())
                    .then(res => {
                        this.totalItems = res["data"];
                        console.log(res["data"]);
                        this.loadedData = true;
                        callback(res["data"]);
                    })
                return null
            }
        }
    }
</script>

<style>
.column_wrapper {
  column-count: 2;
  max-height: 400px;
  display: flex;
  flex-flow: column wrap;
  
  
}
</style>